import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	TextField,
	Button,
} from "@material-ui/core";

import ButtonWithSpinner from "../../components/ButtonWithSpinner";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";

const TestConnectionDialog = ({ open, onClose, onCreated }) => {
	const [name, setName] = useState("");
	const [submitting, setSubmitting] = useState(false);

	useEffect(() => {
		if (open) {
			setName(i18n.t("testMode.dialog.defaultName"));
		}
	}, [open]);

	const handleClose = () => {
		if (submitting) return;
		onClose();
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		const connectionName =
			name.trim() || i18n.t("testMode.dialog.defaultName");

		setSubmitting(true);
		try {
			const { data } = await api.post("/whatsapp", {
				name: connectionName,
				isTest: true,
				queueIds: [],
			});
			toast.success(i18n.t("testMode.toasts.connectionCreated"));
			onCreated(data);
		} catch (err) {
			toastError(err);
		}
		setSubmitting(false);
	};

	return (
		<Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
			<form onSubmit={handleSubmit}>
				<DialogTitle>{i18n.t("testMode.dialog.title")}</DialogTitle>
				<DialogContent dividers>
					<DialogContentText>
						{i18n.t("testMode.dialog.description")}
					</DialogContentText>
					<TextField
						autoFocus
						fullWidth
						variant="outlined"
						size="small"
						label={i18n.t("testMode.dialog.nameLabel")}
						value={name}
						onChange={(e) => setName(e.target.value)}
						disabled={submitting}
					/>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={handleClose}
						color="secondary"
						variant="outlined"
						disabled={submitting}
					>
						{i18n.t("testMode.dialog.cancel")}
					</Button>
					<ButtonWithSpinner
						type="submit"
						color="primary"
						variant="contained"
						loading={submitting}
					>
						{i18n.t("testMode.dialog.create")}
					</ButtonWithSpinner>
				</DialogActions>
			</form>
		</Dialog>
	);
};

export default TestConnectionDialog;
